module.exports = __webpack_public_path__ + "static/img/newsimg4.1ae9f7e4.jpg";